import React from 'react'

import './Footer.scss'

import images from 'assets/images'

const arrMenuFt = [
  {
    title: 'About Viction',
    status: 'left',
    link: '/',
  },
  {
    title: 'Contact Us',
    status: 'left',
    link: 'https://forms.gle/CH3pGKQT16FdJ97L8',
    isBlank: true,
  },
  {
    title: 'X',
    status: 'right',
    link: 'https://x.com/BuildOnViction',
    isBlank: true,
  },
  {
    title: 'Discord',
    status: 'right',
    link: 'https://viction.link/discord',
    isBlank: true,
  },
  {
    title: 'Telegram',
    status: 'right',
    link: 'https://viction.link/telegram',
    isBlank: true,
  },
]

function FooterStableCoin() {
  return (
    <div className='ft-stable-coin-box'>
      <img src={images.backgroundFt} alt='' className='background-ft' />

      <div className='ft-wrapper'>
        <div className='ft-container'>
          <div className='ft-left'>
            {arrMenuFt.map((item, index) => {
              if (item.status === 'left') {
                return (
                  <div className='item-menu' key={index}>
                    <a
                      href={item.link}
                      target={item.isBlank ? '_blank' : ''}
                      rel='nofollow'>
                      {item.title}
                    </a>
                  </div>
                )
              }
            })}
          </div>

          <div className='logo-box'>
            <span className='icon-web_logo logo'></span>
          </div>

          <div className='ft-right'>
            {arrMenuFt.map((item, index) => {
              if (item.status === 'right') {
                return (
                  <div className='item-menu' key={index}>
                    <a
                      href={item.link}
                      target={item.isBlank ? '_blank' : ''}
                      rel='nofollow'>
                      {item.title}
                    </a>
                  </div>
                )
              }
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FooterStableCoin
